<template>
  <div class="card">
    <div class="card-header has-background-white-ter is-relative">

      <b-loading class="card-header-icon" :active="loading" :is-full-page="false" />

      <div class="card-header-title">
        <b-checkbox @input="serviceSelected">
          <b-tag size="is-medium" type="is-primary is-light">{{ code }}</b-tag>
        </b-checkbox>
      </div>

      <a href="/" @click.prevent="removeService" class="card-header-icon has-text-danger">
        <b-button size="is-small"><b-icon icon="delete"></b-icon></b-button>
      </a>

    </div>
    <div class="card-content border-t">
      <div class="columns">
        <div class="column is-8 is-relative">

          <b-field label="Title" horizontal>
            <b-input custom-class="pt-0" placeholder="Title" v-model="title" />
          </b-field>

          <b-field v-if="copy !== undefined" label="Elevator Pitch" horizontal>
            <b-input type="textarea" v-model="copy" placeholder="Elevator Pitch" />
          </b-field>

          <b-field horizontal grouped label="Settings">
            <b-switch v-model="isActive">Active</b-switch>
            <b-switch v-model="hideClosedPicks">Hide Old Picks</b-switch>
            <b-switch v-if="!hideTSSOptions" v-model="isTSS">TSS</b-switch>
          </b-field>

          <b-field horizontal grouped label="Advanced">
            <b-switch v-model="isFree" @input="updateIsFree">Free</b-switch>
            <b-switch v-model="obscurePending" @input="updateObscurePending">Obscure Pending Picks</b-switch>
            <b-switch v-model="getOldRecords" @input="updateGetOldRecords">Get Old Records</b-switch>
          </b-field>

          <b-field horizontal
                   label="Excluded By"
                   :message="excludedByMessage">
            <b-taginput v-model="excludedBy"
                        :data="excludableCodes"
                        autocomplete
                        :open-on-focus="true"
                        @input="updateExcludedBy" />
          </b-field>

          <b-field horizontal grouped label="CBFID/Item/Price">
            <b-input v-model="cbfid" @input="updateCbfid" placeholder="Flow ID" />
            <b-input v-model="cbfidItem" @input="updateCbfidItem" placeholder="Item #" />
            <b-input v-model="cbfidPrice" @input="updateCbfidPrice" placeholder="Price" />
          </b-field>

          <b-field horizontal grouped label="CBFID Settings">
            <b-switch v-model="cbfidIsRecurring" @input="updateCbfidRecurringStatus">Recurring</b-switch>
            <b-input v-if="cbfidIsRecurring" v-model="cbfidTerms" @input="updateCbfidTerms" placeholder="Terms" />
            <b-input v-if="!cbfidIsRecurring" v-model="cbfidDuration" @input="updateCbfidDuration" placeholder="Access Duration" />
            <b-switch v-if="cbfid" v-model="cbfidIsActive" @input="updateCbfidIsActive">Active</b-switch>
          </b-field>

        </div>

        <div class="column">
          <div class="buttons">
            <b-button @click.prevent="() => navTo('picks')"
                      type="is-primary"
                      icon-right="chevron-right"
                      expanded>
              Picks
            </b-button>

            <b-button @click.prevent="() => navTo('links')"
                      type="is-primary"
                      icon-right="chevron-right"
                      expanded>
              Links
            </b-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import debounce from 'underscore/modules/debounce';
import { updateService, logout, removeService } from '@/utils/api';
import {BCheckbox} from 'buefy/dist/esm/checkbox';

export default {
  components: {
    BCheckbox
  },
  props: {
    code: String,
    data: Object,
    allCodes: Array,
  },
  data() {
    return {
      hideTSSOptions: process.env.VUE_APP_NO_TSS,
      loading: false,
      pw: undefined,
      title: undefined,
      isActive: undefined,
      isTSS: undefined,
      paymentLinks: undefined,
      reviews: undefined,
      copy: undefined,
      hideClosedPicks: undefined,
      obscurePending: undefined,
      getOldRecords: undefined,
      excludedBy: [],
      isFree: undefined,
      cbfid: undefined,
      cbfidItem: undefined,
      cbfidPrice: undefined,
      cbfidIsRecurring: undefined,
      cbfidTerms: undefined,
      cbfidDuration: undefined,
      cbfidIsActive: undefined
    }
  },
  mounted() {
    for (let key in this.data) {
      if (key in this) {
        this[key] = this.data[key];
      }
    }

    if (this.cbfidTerms) {
      this.cbfidIsRecurring = true;
    }
  },
  methods: {
    serviceSelected: function (isSelected) {
      let eventName = isSelected ? 'selected' : 'unselected';
      let {code} = this;

      this.$emit(eventName, code);
    },
    navTo: function (dest) {
      let serviceData = JSON.parse(JSON.stringify(this.$data));
      let destinations = {
        'picks' : `/admin/services/${this.code}`,
        'links': `/admin/links/${this.code}`
      }

      serviceData.code = this.code;
      localStorage.setItem('service', JSON.stringify(serviceData));

      this.$router.push(destinations[dest]);
    },
    removeService: async function () {
      this.loading = true;
      await removeService({id: this.code});
      this.loading = false;
      this.$emit('removedService', this.code);
    },
    throttledUpdate: debounce(function (edits) {
      let { code } = this;
      this.loading = true;

      updateService({id: code, edits})
        .then(async res => {
          if (!res.ok) {
            this.$buefy.toast.open({
              duration: 1000,
              message: `ERROR: ${res.status} ${res.statusText}`,
              type: 'is-danger'
            })

            console.log(await res.text());
            await logout({isAdmin: true});
            return this.$router.push('/login')
          }
          this.$buefy.toast.open({
            duration: 700,
            type: 'is-success',
            message: 'Updated!'
          });
        })
        .finally(() => this.loading = false);
    }, 500),
    updateObscurePending: function (newObscurePending) {
      this.throttledUpdate({obscurePending: newObscurePending});
    },
    updateGetOldRecords: function (newGetOldRecords) {
      this.throttledUpdate({getOldRecords: newGetOldRecords});
    },
    updateIsFree: function (newIsFree){
      this.throttledUpdate({isFree: newIsFree});
    },
    updateExcludedBy: function (newExcludedBy) {
      this.throttledUpdate({excludedBy: JSON.parse(JSON.stringify(newExcludedBy))});
    },
    updateCbfid: function (newCbfid) {
      this.throttledUpdate({cbfid: newCbfid});
    },
    updateCbfidItem: function (newCbfidItem) {
      this.throttledUpdate({cbfidItem: newCbfidItem});
    },
    updateCbfidPrice: function (newCbfidPrice) {
      this.throttledUpdate({cbfidPrice: newCbfidPrice});
    },
    updateCbfidTerms: function (newCbfidTerms) {
      if (this.cbfidIsRecurring) {
        return this.throttledUpdate({cbfidTerms: newCbfidTerms});
      }

      this.throttledUpdate({cbfidTerms: false});
    },
    updateCbfidRecurringStatus: function (status) {
      if (!status) {
        this.cbfidTerms = '';
        return this.throttledUpdate({cbfidTerms: ''});
      }
    },
    updateCbfidDuration: function (duration) {
      this.throttledUpdate({cbfidDuration: duration});
    },
    updateCbfidIsActive: function (status) {
      this.throttledUpdate({cbfidIsActive: status});
    }
  },
  watch: {
    hideClosedPicks: function (newClosedPicksOption, oldClosedPicksOption) {
      if (oldClosedPicksOption === undefined) return;

      //this.loading = true;

      this.throttledUpdate({hideClosedPicks: newClosedPicksOption});
    },
    pw: function (newPw, oldPw) {
      // If oldTitle is `undefined`, title is being set to initial value in `mounted` method.
      // No need to update.
      if (oldPw === undefined) return;

      //this.loading = true;

      this.throttledUpdate({pw: newPw});
    },
    title: function (newTitle, oldTitle) {
      if (oldTitle === undefined) return;

      //this.loading = true;

      this.throttledUpdate({title: newTitle});
    },
    isActive: function (newActive, oldActive) {
      if (oldActive === undefined) return;

      //this.loading = true;

      this.throttledUpdate({isActive: newActive});
    },
    isTSS: function (newTSS, oldTSS) {
      if (oldTSS === undefined) return;

      //this.loading = true;

      this.throttledUpdate({isTSS: newTSS});
    },
    reviews: function (newReviews, oldReviews) {
      if (oldReviews === undefined) return;

      //this.loading = true;

      this.throttledUpdate({reviews: newReviews});
    },
    copy: function (newCopy, oldCopy) {
      if (oldCopy === undefined) return;

      //this.loading = true;

      this.throttledUpdate({copy: newCopy});
    }
  },
  computed: {
    excludableCodes: function () {
      return this.allCodes.filter(code => !this.excludedBy.includes(code));
    },
    excludedByMessage: function () {
      if (Array.isArray(this.excludedBy) && this.excludedBy.length) {
        return `Users with access to ${this.excludedBy.join(' or ')} will not see ${this.isFree ? 'the free picks from' : 'an advertisement for'} this service (${this.code})`;
      }

      let exampleServiceCode = this.allCodes.filter(code => code !== this.code)[0];
      let freeExample = `For example, if you don't want users with access to ${exampleServiceCode} to see these free picks (${this.code}), enter ${exampleServiceCode} in the box above.`;
      let example = `If users with access to ${exampleServiceCode || 'VIP'} shouldn't see an ad for this service (${this.code}), enter ${exampleServiceCode || 'VIP'} in the box above.`;

      if (this.isFree) {
        return `
          This free service can be hidden if the user has access to any services listed here.
          ${exampleServiceCode ? freeExample : ''}
        `;
      }

      return `An advertisement for ${this.code} can be hidden from users with access to other services. For example: ${example}`;
    }
  }
}
</script>

<style scoped lang="scss">
@import "~buefy/src/scss/utils/functions";
@import "~buefy/src/scss/utils/variables";
@import "~buefy/src/scss/components/checkbox";
</style>